import { companiesService } from "@/service/services/Companies.service";
import { Alert, Snackbar, Typography } from "@mui/material";
import { useState } from "react";
import { Modal } from "../Modal";
import { ModalBody } from "../ModalBody";
import { ModalFooter } from "../ModalFooter";
import { ModalHeader } from "../ModalHeader";
import { Props } from "./ModalUserDelete.type";
import ___PHRASE from "@/service/translate/translateService";
import { Loading } from "@/components/common/Loading";
import { userService } from "@/service/services/User.service";
import { apiResponseTranslate } from "@/toolbox/helpers/responseApi.helper";

export const ModalUserDelete: React.FC<Props> = (props:any): JSX.Element => {
    const { open, closeModal, role, user, onListUsers, clearState } = props;

    const [loading, setLoading] = useState<boolean>(false);
    const [snackBarConfig, setSnackBarConfig] = useState<any>({
      open: false,
      severity: 'error',
      message: 'Error',
      autoHideDuration: 3000,
  });

    const onDeleted= async()=>{
        setLoading(true);
        const roleUserSession = role;
        await userService.deleteUser(user.iduser, roleUserSession).then((data) => {
          let apimessagge = apiResponseTranslate(data?.data?.message || '');
            if(data.data.status === true){
                setLoading(false);
                setSnackBarConfig(prev => ({ ...prev, open: true, 
                  severity:'success', 
                  message: `${apimessagge || ___PHRASE("usuarioEliminadoSatisfactoriamente.")}` 
                }))
                onListUsers && onListUsers();
                closeModal && closeModal();
            }else{
                setLoading(false);
                return (
                    setSnackBarConfig(prev => ({ ...prev, open: true, 
                        severity:'error', 
                        message: `${apimessagge || ___PHRASE("ocurrioAlgunErrorIntentaloMasTarde")}` 
                    }))
                )
            }
        })
        setLoading(false);
    }
  
  return (
    <>
     {loading && <Loading/>}
    <Snackbar
            open={snackBarConfig.open} 
            autoHideDuration={snackBarConfig.autoHideDuration} 
            onClose={() => setSnackBarConfig(prev => ({ ...prev, open: false }))}
            anchorOrigin={{ vertical: 'top', horizontal:'right' }} >
            <Alert onClose={() => setSnackBarConfig(prev => ({ ...prev, open: false }))} severity={snackBarConfig.severity}>
                {snackBarConfig.message || ""}
            </Alert>
    </Snackbar>
    <Modal
      open={open}
      disableEscapeKeyDown disableBackdropClick
      handleClose={closeModal}
      size="xs"
    >
      <ModalHeader
        text={___PHRASE("eliminar")+' '+___PHRASE("usuario")}
        className='positionElements'
        onCancel={closeModal}
        clearState={clearState}
      >
      </ModalHeader>

      <ModalBody>
        <Typography variant="subtitle1" className="textColor"> 
          {___PHRASE("estaSeguroDeEliminarEsteUsuario")}
        </Typography>
      </ModalBody>

      <ModalFooter 
        confirmText={___PHRASE("eliminar")}
        cancelText={___PHRASE("cancelar")}
        onCancel={closeModal}
        className="footerRight"
        onConfirm={onDeleted}
        clearState={clearState}
      />
    </Modal>
    </>
  )
}